<template>
<div class="chapter">
<div class="inner_page">
<p class="subtitle"><a id="page_1"></a>W<span class="smallcaps">EST</span> W<span class="smallcaps">ALES</span> R<span class="smallcaps">AILWAYS</span></p>
<p class="halftitle">CARMARTHEN TO FISHGUARD HARBOUR</p>
<div class="img_containerr"><img alt="images" src="images/f0001-01.jpg"/><a id="page_2"></a></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?1c26e282